'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _availabilityStatus = require('@bibliocommons/availability-status');

var _availabilityStatus2 = _interopRequireDefault(_availabilityStatus);

var _holdCounts = require('@bibliocommons/hold-counts');

var _holdCounts2 = _interopRequireDefault(_holdCounts);

var _baseIcons = require('@bibliocommons/base-icons');

var _sharedProbeLogo = require('@bibliocommons/shared-probe-logo');

var _sharedProbeLogo2 = _interopRequireDefault(_sharedProbeLogo);

require('../styles/HoldingsProbe.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HoldingsProbe(props) {
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('cp-holdings-probe', props.rollupStatus.toLowerCase()) },
    _react2.default.createElement(
      'div',
      { className: 'library-image' },
      _react2.default.createElement(_sharedProbeLogo2.default, { circled: true, small: true, siteId: props.siteId })
    ),
    _react2.default.createElement(
      'div',
      { className: 'holdings-info' },
      _react2.default.createElement(
        'a',
        { className: 'library-name', href: props.bibUrl, target: '_blank', rel: 'noopener noreferrer' },
        props.libraryName,
        ' ',
        _react2.default.createElement(_baseIcons.Arrows.long.Right, null)
      ),
      _react2.default.createElement(_availabilityStatus2.default, { status: props.availabilityStatus, rollUpStatus: props.rollupStatus }),
      !props.availabilityStatus ? _react2.default.createElement(
        'a',
        { href: props.bibUrl, className: 'check-avail-link', target: '_blank', rel: 'noopener noreferrer' },
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'check_digital_availability' })
      ) : null,
      _react2.default.createElement(_holdCounts2.default, {
        availableCopies: props.availableCopies,
        totalCopies: props.totalCopies,
        heldCopies: props.heldCopies })
    )
  );
}

HoldingsProbe.propTypes = {
  libraryName: _react.PropTypes.string.isRequired,
  siteId: _react.PropTypes.string.isRequired,
  availabilityStatus: _react.PropTypes.string.isRequired,
  rollupStatus: _react.PropTypes.string.isRequired,
  availableCopies: _react.PropTypes.number.isRequired,
  heldCopies: _react.PropTypes.number.isRequired,
  totalCopies: _react.PropTypes.number.isRequired,
  bibUrl: _react.PropTypes.string.isRequired
};

exports.default = HoldingsProbe;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/probes/lib/components/holdings-probe/components/HoldingsProbe.component.js
// module id = 1452
// module chunks = 1